import React, { createContext, useContext, useEffect, useReducer, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App'
import { ContentBodyContext } from '../MainContent';
import MessageList from './MessageList'
import MessageBody from './MessageBody';
import ModalNewMessage from './ModalNewMessage';
import ModalAttachment from './ModalAttachment';
import swal from 'sweetalert';
import jwt from 'jwt-decode'
import ModalFeedback from './ModalFeedback';

export const MessageContext = createContext();
function Message() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext)

    const initialReducer = {
        showChat: false,
        modal: false,
        selected: null,
        listMessages: {
            content: [],
            row: 0
        },
        message: {
            content: [],
            row: 0,
            status: true
        },
        prevChat: [],
        trigger: { message: null, data: null, action: { name: null, data: null } },
        tempListMessage: null,
        tempMessage: null,
        modalAttachment: false,
        modalFeedback: { status: false, data: null },
    }
    const reducer = (state, action) => {
        switch (action.type) {
            case "SHOW_CHAT":
                return {
                    ...state,
                    showChat: action.showChat,
                    selected: action.selected
                }
            case "NEW_CHAT":
                return {
                    ...state,
                    modal: action.modal
                }
            case "LIST_CHATS":
                return {
                    ...state,
                    listMessages: action.listMessages
                }
            case "MESSAGE":
                return {
                    ...state,
                    message: action.message
                }
            case "TRIGGER":
                return {
                    ...state,
                    trigger: action.trigger
                }
            case "TEMP_LIST":
                return {
                    ...state,
                    tempListMessage: action.tempListMessage
                }
            case "TEMP_MESSAGE":
                return {
                    ...state,
                    tempMessage: action.tempMessage
                }
            case "MODAL_ATTACH":
                return {
                    ...state,
                    modalAttachment: action.modalAttachment
                }
            case "MODAL_FEEDBACK":
                return {
                    ...state,
                    modalFeedback: action.modalFeedback
                }
            case "PREV_CHAT":
                return {
                    ...state,
                    prevChat: action.prevChat
                }
        }
    }
    const [stateMessage, dispatchMessage] = useReducer(reducer, initialReducer)

    const [tempResult, settempResult] = useState(null)
    useEffect(() => {
        //send chat success
        stateContentBody.socket.on(`helpdesk-chat-success-${jwt(localStorage.getItem('token-helpdesk-umy')).id}`, function (res) {
            //handle duplicate
            if (tempResult != res) {
                dispatchMessage({
                    type: 'TRIGGER',
                    trigger: { message: 'helpdesk-chat', data: 'success', action: { name: res.action, data: res.data } },
                })
                settempResult(res)
            }
        })

        //send chat failed
        stateContentBody.socket.on(`helpdesk-chat-error-${jwt(localStorage.getItem('token-helpdesk-umy')).id}`, function (res) {
            dispatchMessage({
                type: 'TRIGGER',
                trigger: { message: 'helpdesk-chat', data: 'error', action: { name: res.action, data: null } },
            })
            if (res.message == `jwt expired`) {
                dispatchAuth({
                    type: "LOGOUT",
                    message: 'Token expired, please login again...'
                })
            } else {
                swal("Error!", `${res.message.replace('jwt', 'Token')}`, "error", {
                    button: "OK",
                });
            }
        })

        //recieve new message
        stateContentBody.socket.on(`helpdesk-chat-callback`, function (res) {
            //handle duplicate
            if (tempResult != res) {
                dispatchMessage({
                    type: 'TRIGGER',
                    trigger: { message: 'helpdesk-chat', data: 'success', action: { name: res.action, data: res.data } },
                })
                settempResult(res)
            }
        })

        //close chat failed
        stateContentBody.socket.on(`helpdesk-user-feedback-close-error-${jwt(localStorage.getItem('token-helpdesk-umy')).id}`, function (res) {
            dispatchMessage({
                type: 'TRIGGER',
                trigger: { message: 'helpdesk-user-feedback-close', data: 'error', action: { name: res.action, data: res.data } },
            })
            if (res.message == `jwt expired`) {
                dispatchAuth({
                    type: "LOGOUT",
                    message: 'Token expired, please login again...'
                })
            } else {
                swal("Error!", `${res.message.replace('jwt', 'Token')}`, "error", {
                    button: "OK",
                });
            }
        })

        //close chat success
        stateContentBody.socket.on(`helpdesk-user-feedback-close-success-${jwt(localStorage.getItem('token-helpdesk-umy')).id}`, function (res) {
            //handle duplicate
            if (tempResult != res) {
                dispatchMessage({
                    type: 'TRIGGER',
                    trigger: { message: 'helpdesk-user-feedback-close', data: 'success', action: { name: res.data.action, data: res.data } },
                })
                settempResult(res)
            }
        })

        //feedback close chat by admin
        stateContentBody.socket.on(`helpdesk-user-feedback-close-callback`, function (res) {
            dispatchMessage({
                type: 'TRIGGER',
                trigger: { message: 'helpdesk-user-feedback-close', data: 'success', action: { name: res.data.action, data: res.data } },
            })
        })
    }, [])

    const [renderMessage, setrenderMessage] = useState(<MessageList />)
    useEffect(() => {
        if (stateMessage.showChat) {
            setrenderMessage(
                <Fragment>
                    <MessageBody />
                </Fragment>
            )
        } else {
            setrenderMessage(
                <Fragment>
                    <MessageList />
                </Fragment>
            )
        }
    }, [stateMessage.showChat])

    return (
        <Fragment>
            <div className="d-flex justify-content-center pl-0 pr-0" >
                <div className=" col-lg-6 col-md-8 col-sm-12  mt-0 pt-0 pr-0 pl-0" >
                    <MessageContext.Provider value={{ stateMessage, dispatchMessage }}>
                        {renderMessage}
                    </MessageContext.Provider>
                </div>
            </div>
            <MessageContext.Provider value={{ stateMessage, dispatchMessage }}>
                <ModalNewMessage />
                <ModalAttachment />
                <ModalFeedback />
            </MessageContext.Provider>
        </Fragment>
    )
}

export default Message
